import { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";

import "./GuestList.css";
import { db } from "../../../firebase/firebase";
import { QrGuestScanScreen } from "../../main-screen/admin/admin-scan-qr/QRGuestScanScreen";
import LogoutButton from "../../login/logout/LogoutButton";

export type Guest = {
  name: string;
  token: string;
  invited: number;
  confirmed: number;
  hasConfirmed: boolean;
  phoneNumber: string;
  guests?: string[];
  table?: number;
  testAccount?: boolean;
};

export const GuestList = () => {
  const [guests, setGuests] = useState<Guest[]>([]);

  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [errors, setErrors] = useState<{
    name?: string;
    invited?: string;
    phoneNumber?: string;
    guestNames?: string[];
  }>({});

  const fetchGuests = async () => {
    const snap = await getDocs(collection(db, "guests"));
    const allGuests = snap.docs.map((d) => d.data() as Guest);

    const filteredGuests = allGuests.filter(
      (guest) => !guest.testAccount && guest.token !== "bigz0u"
    );

    setGuests(filteredGuests);
  };

  const updateConfirmationStatus = async (
    token: string,
    status: boolean | null
  ) => {
    try {
      const guestRef = doc(db, "guests", token);
      const updateData =
        status === null
          ? { hasConfirmed: false, confirmed: 0 }
          : { hasConfirmed: true, confirmed: status ? 1 : 0 };

      await setDoc(guestRef, updateData, { merge: true });
      await fetchGuests();
    } catch (error) {
      alert("Error al actualizar estado:" + error);
    }
  };

  useEffect(() => {
    fetchGuests();
  }, []);

  return (
    <>
      <div className="guest-panel">
        <LogoutButton />
        {/* Tabla de invitados */}
        <h4>Lista de invitados</h4>
        <div className="guest-table-header">
          <button
            className="search-toggle"
            onClick={() => setShowSearch((prev) => !prev)}
          >
            🔍
          </button>
          {showSearch && (
            <input
              type="text"
              placeholder="Buscar por nombre..."
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          )}
        </div>
        <div className="guest-table-container">
          <table className="guest-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Número de teléfono</th>
                <th>N° Pases</th>
                <th>N° Pases Confirmados</th>
                {/* <th>¿Confirmado?</th> */}
                <th>Mesa</th>
                <th>Asistencia</th>
              </tr>
            </thead>
            <tbody>
              {guests
                .filter((g) =>
                  g.name
                    .toLowerCase()
                    .includes(searchQuery.trim().toLowerCase())
                )
                .sort((a, b) => {
                  const tableA = a.table ?? 9999;
                  const tableB = b.table ?? 9999;
                  return tableA - tableB;
                })
                .map((guest) => (
                  <tr key={guest.token}>
                    <td>{guest.name}</td>
                    <td>{guest.phoneNumber}</td>
                    <td>{guest.invited}</td>
                    <td>{guest.confirmed}</td>
                    {/* <td>
                      {guest.hasConfirmed ? (
                        guest.confirmed > 0 ? (
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            ✅ Confirmado
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            ❌ No asiste
                          </span>
                        )
                      ) : (
                        <span style={{ color: "#8c906c", fontWeight: "bold" }}>
                          ⏳ Pendiente
                        </span>
                      )}
                    </td> */}
                    <td>{guest.table ?? "-"}</td>
                    <td>
                      <select
                        value={
                          guest.hasConfirmed
                            ? guest.confirmed > 0
                              ? "yes"
                              : "no"
                            : "pending"
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "yes")
                            updateConfirmationStatus(guest.token, true);
                          else if (value === "no")
                            updateConfirmationStatus(guest.token, false);
                          else updateConfirmationStatus(guest.token, null); // null para pendiente
                        }}
                        className="status-select"
                      >
                        <option value="pending">⏳ Pendiente</option>
                        <option value="yes">✅ Aceptó</option>
                        <option value="no">❌ Rechazó</option>
                      </select>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <QrGuestScanScreen />
    </>
  );
};
